import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { CloseOval } from 'components/SvgIcons';
import './styles.scss';

class RoundedImg extends PureComponent {
    renderImg = (src) => {
        const {
            className,
            diameter,
            dismissible,
            alt,
            onClick = () => null,
            onClickDismissible = () => null,
        } = this.props;
        const containerClass = `rounded-img-container ${className !== undefined ? className : ''}`;

        return (
            <div className={containerClass} style={{ width: diameter, height: diameter }}>
                <img
                    className="rounded-img"
                    src={src}
                    style={{ width: diameter, height: diameter }}
                    alt={alt}
                    onClick={onClick}
                />
                {dismissible && (
                    <div
                        className="rounded-img__close-btn"
                        role="button"
                        tabIndex="-1"
                        onClick={onClickDismissible}
                    >
                        <CloseOval color="#979797" />
                    </div>
                )}
            </div>
        );
    };

    renderLetters = () => {
        const { alt, diameter, className = '', onClick = () => null } = this.props;

        const char = alt.indexOf('_') !== -1 ? '_' : ' ';
        const altSplit = alt.split(char);
        let altStr;
        if (altSplit.length >= 2) {
            altStr = altSplit[0][0] + altSplit[1][0];
        } else {
            altStr = alt.substr(0, 2);
        }

        const imgClass = `rounded-img-empty ${className !== undefined ? className : ''}`;

        return (
            <div
                role="button"
                tabIndex="-1"
                className={imgClass}
                style={{
                    width: diameter,
                    height: diameter,
                    fontSize: diameter / 2,
                    lineHeight: `${diameter}px`,
                }}
                onClick={onClick}
            >
                {altStr}
            </div>
        );
    };

    render() {
        const { defaultImg } = this.props;
        let { src = '' } = this.props;

        if (src !== undefined && src.length > 0) {
            if (src.indexOf('data:image') === -1 && src.indexOf('http') === -1) {
                src = `data:image/png;base64,${src}`;
            }
            return this.renderImg(src);
        }
        if (defaultImg !== null) {
            return this.renderImg(defaultImg);
        }
        return this.renderLetters();
    }
}

RoundedImg.propTypes = {
    src: PropTypes.string,
    diameter: PropTypes.number.isRequired,
    alt: PropTypes.string.isRequired,
    className: PropTypes.string,
    onClick: PropTypes.func,
    defaultImg: PropTypes.string,
    dismissible: PropTypes.bool,
    onClickDismissible: PropTypes.func,
};

export default RoundedImg;
